/**
 * Mixin pozwala na używanie computed property "initialized" w celu ukrywania komponentów,
 * które nie powinny renderować się zanim nie skończą się wszystkie wywołania do Api z "computed".
 */

import {Api} from "../api";

export const Initializator = {

	computed: {
		initialized() {
			return Api.initializationCompleted();
		},
	},

	created() {
		Api.prepareInitialization();
	},

};
